import React from "react";
import { Timeline } from "./features/timeline";

const App: React.FC = () => {
    return <Timeline />
};

export default App;
